/*
==============================================================================
NSG EDITORIAL DIRECTOR
Lugares con Alma
Version: 2.4.3
==============================================================================
*/

(() => {
  'use strict';

  const roots = new WeakSet();

  const initEditorial = (editorial) => {
    if (!editorial || roots.has(editorial)) return;
    roots.add(editorial);

    document.documentElement.classList.add('nsg-has-editorial');

    editorial.querySelectorAll('[data-nsg-scroll-next]').forEach((button) => {
      button.addEventListener('click', () => {
        const scene = button.closest('[data-nsg-scene]');
        const nextScene = scene ? scene.nextElementSibling : null;

        if (nextScene) {
          nextScene.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    const scenes = editorial.querySelectorAll('[data-nsg-scene]:not(:first-child)');

    // En el editor de Shopify el contenido debe permanecer visible mientras se configura.
    if (window.Shopify && Shopify.designMode) {
      scenes.forEach((scene) => scene.classList.add('is-visible'));
    }

    // Salvaguarda: ninguna escena puede quedar oculta por un fallo de observer o caché.
    window.setTimeout(() => {
      scenes.forEach((scene) => scene.classList.add('is-visible'));
    }, 1200);

    if ('IntersectionObserver' in window) {
      const sceneObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.08
        }
      );

      scenes.forEach((scene) => sceneObserver.observe(scene));
    } else {
      scenes.forEach((scene) => scene.classList.add('is-visible'));
    }

    const progressBar = editorial.querySelector('[data-nsg-editorial-progress-bar]');

    if (progressBar) {
      const updateProgress = () => {
        const rect = editorial.getBoundingClientRect();
        const scrollableDistance = Math.max(editorial.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / scrollableDistance, 0), 1);
        progressBar.style.transform = `scaleX(${progress})`;
      };

      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
    }
  };

  const updateHeader = () => {
    document.documentElement.classList.toggle('nsg-header-scrolled', window.scrollY > 48);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-nsg-editorial]').forEach(initEditorial);
    updateHeader();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  window.addEventListener('scroll', updateHeader, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();


/* V2.2 · Movimiento editorial de la escena Descubrir el lugar */
(() => {
  const scenes = document.querySelectorAll('[data-nsg-discovery].nsg-discovery--motion');
  if (!scenes.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;

  const update = () => {
    const viewport = window.innerHeight || document.documentElement.clientHeight;

    scenes.forEach((scene) => {
      const media = scene.querySelector('[data-nsg-discovery-media]');
      if (!media) return;

      const rect = scene.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewport) return;

      const progress = (viewport - rect.top) / (viewport + rect.height);
      const shift = Math.max(-18, Math.min(18, (progress - 0.5) * 36));
      media.style.setProperty('--nsg-discovery-shift', `${shift.toFixed(2)}px`);
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', requestUpdate);
  requestUpdate();
})();


/* El Alma del Lugar · revelado independiente de cada imagen */
(() => {
  const initSoulScenes = (scope = document) => {
    const moments = scope.querySelectorAll('[data-nsg-soul-moment]:not([data-nsg-soul-ready])');
    if (!moments.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    moments.forEach((moment) => moment.setAttribute('data-nsg-soul-ready', 'true'));

    if (reduced || !('IntersectionObserver' in window)) {
      moments.forEach((moment) => moment.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.22, rootMargin: '0px 0px -8% 0px' });

    moments.forEach((moment) => observer.observe(moment));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSoulScenes(), { once: true });
  } else {
    initSoulScenes();
  }

  document.addEventListener('shopify:section:load', (event) => initSoulScenes(event.target));
})();
